import { OPTIONS } from './constants';
import { View } from './types';

export const viewToIndex = (view: View): number =>
  OPTIONS.findIndex((opt) => opt.value === view);
